/** @jsxImportSource ../../i18n */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { cx } from '../../theme/cx';
import { formatDate } from '../../theme/format';

export const IMPACTS = {
  positive: { label: 'Impact positif', dot: 'bg-gain-400', text: 'text-gain-300', tone: 'gain' },
  negative: { label: 'Impact négatif', dot: 'bg-loss-400', text: 'text-loss-300', tone: 'loss' },
  neutral: { label: 'Impact neutre', dot: 'bg-fg-faint', text: 'text-fg-muted', tone: 'neutral' },
};

export const impactOf = (impact) => IMPACTS[impact] || IMPACTS.neutral;

export const newsDate = (value) => (/^\d{4}-\d{2}-\d{2}/.test(value || '') ? formatDate(String(value).slice(0, 10)) : value);

export const ImpactDot = ({ impact, className }) => {
  const meta = impactOf(impact);
  return (
    <span className={cx('inline-flex flex-shrink-0 items-center', className)}>
      <span aria-hidden="true" className={cx('h-2 w-2 rounded-full', meta.dot)} />
      <span className="sr-only">{meta.label}</span>
    </span>
  );
};

// flush: no outer padding on the first/last item (list inside a padded card).
export const NewsItem = ({ item, showSymbol = true, flush = true, className }) => (
  <article className={cx('group/news flex gap-3.5 py-4', flush && 'first:pt-0 last:pb-0', className)}>
    <ImpactDot impact={item.impact} className="mt-[7px]" />
    <div className="min-w-0 flex-1">
      <p className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-fg-subtle">
        {showSymbol && item.symbol && (
          <Link to={`/stock/${encodeURIComponent(item.symbol)}`} className="font-semibold text-gold-300 transition-colors hover:text-gold-200">
            {item.symbol}
          </Link>
        )}
        {item.date && <span>{newsDate(item.date)}</span>}
        {item.source && (
          <>
            <span aria-hidden="true" className="text-fg-faint">·</span>
            <span>{item.source}</span>
          </>
        )}
      </p>
      {item.url ? (
        <a href={item.url} target="_blank" rel="noopener noreferrer" className="mt-1 inline-flex items-start gap-1 text-[15px] font-medium leading-snug text-fg transition-colors hover:text-gold-200">
          <span>{item.headline}</span>
          <ArrowUpRight size={14} aria-hidden="true" className="mt-1 flex-shrink-0 text-fg-faint transition-colors group-hover/news:text-gold-400" />
        </a>
      ) : (
        <p className="mt-1 text-[15px] font-medium leading-snug text-fg">{item.headline}</p>
      )}
      {item.summary && <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-fg-muted">{item.summary}</p>}
    </div>
  </article>
);
